import React, { useState, useRef, useEffect,useContext } from 'react';
import { DayPicker } from 'react-day-picker';
import { ptBR } from 'date-fns/locale';
import 'react-day-picker/style.css';
import './custom-calendar.css';
import styled from 'styled-components';
import calendarIcon from '../../images/svg/calendar 1.svg';
import { RequestsContext } from '../../context/requests';
import { FilterSallesContext } from '../../context/filterSalles';

const CardWrapper = styled.div`
  margin-top: 0.7rem;
  padding-left: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  text-indent:32px;
  border: 1px solid black;
  color: black;
  width: 200px;
  height: 35px;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  border-radius: 6px;
`;

const BoxInput = styled.div`
  position: relative;
`;

const ImageCalendar = styled.img`
  position: absolute;
  left: 7px;
  top: 10px;
  width: 16px;
`;

const Button = styled.button`
  font-family: "Poppins";
  font-weight: 500;
  border-radius: 19px;
  border: none;
  width: 91px;
  font-size: 0.9rem;
  height: 31.6px;
  color: white;
  background-color: #0050dc;
  margin-bottom: 0.5rem;

`;

const Of = styled.div`
  padding: 0.5rem;
  font-family: "Poppins";
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 0.7em;
  top: 5px;
  left:5px;
  width: 25px;
  height: 25px;
  color:#cfcfcf;
  background-color: #373839;
  border-radius:15px;
`

const Until = styled.div`
  padding: 0.5rem;
  font-family: "Poppins";
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 0.7em;
  top: 5px;
  left:5px;
  width: 25px;
  height: 25px;
  color:#cfcfcf;
  background-color: #373839;
  border-radius:15px;
`

function MultipleDatePicker() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const {setStartDateFilter,setEndDateFilter,getRangeDate} = useContext(RequestsContext)
  const {option} = useContext(FilterSallesContext)

  const [showStartPicker, setShowStartPicker] = useState(false);
  const [showEndPicker, setShowEndPicker] = useState(false);

  const startPickerRef = useRef();
  const endPickerRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        startPickerRef.current && !startPickerRef.current.contains(event.target)
      ) {
        setShowStartPicker(false);
      }

      if (
        endPickerRef.current && !endPickerRef.current.contains(event.target)
      ) {
        setShowEndPicker(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <CardWrapper>
      {/* Data de Início */}
      <BoxInput ref={startPickerRef}>
        <Input
          type="text"
          readOnly
          value={startDate ? startDate.toLocaleDateString('pt-BR') : ''}
          onClick={() => setShowStartPicker(!showStartPicker)}
          placeholder="Data de Início"
        />
        <Of>De</Of>
        {showStartPicker && (
          <div style={{
            position: "absolute",
            zIndex: 100,
            background: "white",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginTop: '5px'
          }}>
            <DayPicker
              mode="single"
              selected={startDate}
              onSelect={(date) => {
                localStorage.setItem("@DATE_UNIQ_START",date)
                setStartDateFilter(date);
                setStartDate(date);
                setShowStartPicker(false);
              }}
              locale={ptBR}
              className="custom-calendar"
            />
          </div>
        )}
      </BoxInput>

      {/* Data de Fim */}
      <BoxInput ref={endPickerRef}>
        <Input
          type="text"
          readOnly
          value={endDate ? endDate.toLocaleDateString('pt-BR') : ''}
          onClick={() => setShowEndPicker(!showEndPicker)}
          placeholder="Data de Fim"
        />
        <Until>Até</Until>
        {showEndPicker && (
          <div style={{
            position: "absolute",
            zIndex: 100,
            background: "white",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginTop: '5px'
          }}>
            <DayPicker
              mode="single"
              selected={endDate}
              onSelect={(date) => {
                localStorage.setItem("@DATE_UNIQ_END",date)
                setEndDateFilter(date);
                setEndDate(date);
                setShowEndPicker(false);
              }}
              locale={ptBR}
              className="custom-calendar"
            />
          </div>
        )}
      </BoxInput>

      <Button onClick={() => getRangeDate(option)}>
        Aplicar
      </Button>
    </CardWrapper>
  );
}

export default MultipleDatePicker;
